export const labelMap={
    ebit_margin_perc:"EBIT Margin Percent",
    gross_profit_margin:"Gross Profit Margin",
    net_margin:"Net Margin",
    revenue_growth:"Revenue Growth",
    ebitda_margin_perc:"EBITDA Margin Percent",
    DSO:"DSO",
    DPO:"DPO",
    DIO:"DIO",
    opex_perc_revenue:"Revenue"

}
export const getLabelKey = (val) =>{
   return Object.keys(labelMap).find(key=>labelMap[key]==val) 
} 
export const mapKpi = (data,val) =>{

        return data?.map(
            (value) => ({label:labelMap[value.func_kpi],key:value.func_kpi}))
    
  }